export const ACTIONS = {
  BANK: 'BANK',
  PAYMENT_METHOD: 'PAYMENTMETHOD',
  MOUNT: 'MOUNT',
  REFERENCE: 'REFERENCE',
  IMAGE: 'IMAGE',
  CHANGETYPE: 'CHANGETYPE',
  PAYMENTDATE: 'PAYMENTDATE',
} as const;
